<script setup>
const user = useState('user')
</script>

<template lang="pug">
div.web-header.relative.shadow-md.bg-white
  div.stripe.h-3.bg-gradient-to-r.from-primary-600.to-primary-400
  AppContainer
    .h-8
    div(class="md:flex-row md:justify-between md:items-center").flex.flex-col.justify-start.items-center
      Logo(class="w-9/12 md:w-auto md:flex-1 h-12")
      div(class="md:my-0").flex.flex-row.justify-end.items-center.mt-4
        WebHeaderNav(to="/articles") 比赛资讯
        WebHeaderNav(to="/qna") Q&A
        WebHeaderNav(to="/app" primary v-if="user") @{{ user.username }}
        WebHeaderNav(to="/signin" primary v-else) 赛队登录
    .h-8
</template>
